import { CONTACT_LISTS_API_URL, CONTACT_LISTS_FILTER_URL, CONTACT_LISTS_TEMPLATE_DOWNLOAD_URL } from 'constants/ApiConstants';

import * as types from 'modules/contactLists/actionTypes';
import { getTemplate as getTemplateMedia } from 'modules/medias/actions';

/**
 * @param {unknown} params
 * @param {Object} [meta={}]
 * @returns {import("../types").FetchContactListsAction}
 */
export const fetchContactLists = (params, meta = {}) => ({
  type: types.FETCH_CONTACT_LISTS,
  payload: {
    request: {
      method: 'GET',
      url: CONTACT_LISTS_FILTER_URL,
      params,
    },
  },
  meta: {
    '@app-request': true,
    ...meta,
  },
});

/**
 * @param {string} contactListId
 * @param {Object} [meta={}]
 * @returns {import("../types").FetchContactListAction}
 */
export const fetchContactList = (contactListId, meta = {}) => ({
  type: types.FETCH_CONTACT_LIST,
  payload: {
    request: {
      method: 'GET',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}`,
      params: {
        projection: 'details',
      },
    },
  },
  meta: {
    '@app-request': true,
    ...meta,
  },
});

/**
 * @param {import("../types").DetailedContactList} contactList
 * @param {Object} [meta={}]
 * @returns {import("../types").FetchContactListSuccessAction}
 */
export const fetchContactListSuccess = (contactList, meta = {}) => ({
  type: types.FETCH_CONTACT_LIST_SUCCESS,
  payload: contactList,
  meta,
});

/**
 *
 * @param {Partial<import("../types").DetailedContactList>} contactList
 * @param {Object} [meta={}]
 * @returns {import("../types").CreateContactListAction}
 */
export const createContactList = (contactList, meta = {}) => ({
  type: types.CREATE_CONTACT_LIST,
  payload: {
    request: {
      method: 'POST',
      url: CONTACT_LISTS_API_URL,
      data: contactList,
    },
  },
  meta,
});

/**
 *
 * @param {import("../types").DetailedContactList} contactList
 * @param {Object} [meta={}]
 * @returns {import("../types").UpdateContactListAction}
 */
export const updateContactList = (contactList, meta = {}) => ({
  type: types.UPDATE_CONTACT_LIST,
  payload: {
    request: {
      method: 'PUT',
      url: `${CONTACT_LISTS_API_URL}/${contactList.id}`,
      data: contactList,
    },
  },
  meta,
});

/**
 * @param {string} contactListId
 * @param {Object} [meta={}]
 * @returns {import("../types").DeleteContactListAction}
 */
export const deleteContactList = (contactListId, meta = {}) => ({
  type: types.DELETE_CONTACT_LIST,
  payload: {
    contactListId,
    request: {
      method: 'DELETE',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}`,
    },
  },
  meta,
});

/**
 * @param {string} contactListId
 * @param {Object} [meta={}]
 * @returns {import("../types").DeleteContactListSuccessAction}
 */
export const deleteContactListSuccess = (contactListId, meta = {}) => ({
  type: types.DELETE_CONTACT_LIST_SUCCESS,
  payload: contactListId,
  meta,
});

/**
 * @param {string} contactListId
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import("../types").DeleteContactListFailureAction}
 */
export const deleteContactListFailure = (contactListId, error, meta = {}) => ({
  type: types.DELETE_CONTACT_LIST_FAILURE,
  payload: { contactListId, error },
  error: true,
  meta,
});

/**
 * @param {string} contactListId
 * @param {string} mode - 'UPLOAD' | 'MANUALLY'
 * @returns {import("../types").OpenAddContactsModalAction}
 */
export const openAddContactsModal = (contactListId, mode) => ({
  type: types.OPEN_ADD_CONTACTS_MODAL,
  payload: { contactListId, mode },
});

/**
 * @param {string} [payload]
 * @param {Object={}} meta
 * @returns {import("../types").CloseAddContactsModalAction}
 */
export const closeAddContactsModal = (payload, meta = {}) => ({
  payload,
  type: types.CLOSE_ADD_CONTACTS_MODAL,
  meta,
});

/**
 * @param {string} contactListId
 * @param {{ customerInfo: import("../types").CustomerInfo, vehicleInfo?: import("../types").VehicleInfo, resubscribe?: boolean, consent?: boolean }} data
 * @param {Object} [meta={}]
 * @return {import("../types").AddContactsAction}
 */
export const addContacts = (contactListId, { resubscribe, consent, ...data }, meta = {}) => ({
  type: types.ADD_CONTACTS,
  payload: {
    request: {
      method: 'POST',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}/members`,
      params: { resubscribe, consent },
      data,
    },
  },
  meta,
});

/**
 * @param {{ language: string, extension: 'csv' | 'xlsx' | string }} params
 * @return {import("../types").GetTemplateAction}
 */
export const getTemplate = (params, meta = {}) => getTemplateMedia(
  {
    url: CONTACT_LISTS_TEMPLATE_DOWNLOAD_URL,
    params,
  },
  meta
);
